import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../../services/user/user.service';

export const authGuard: CanActivateFn = (route) => {
  const a = route.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join('/')).join('/');
  if (a.includes('auth')) {
    return inject(UserService).blockAuthPages();
  }
  return inject(UserService).getIsUserAuth();
};
